export default __webpack_public_path__ + "static/media/img_agree_sns.f46c70b5.svg";